/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Shortforms_AddedInputs */

const en_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No shortforms added to this list yet`)
};

const fr_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune abréviation ajoutée à cette liste`)
};

const de_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Liste wurden noch keine Kurzformen hinzugefügt.`)
};

const it_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna forma abbreviata è stata ancora aggiunta a questo elenco`)
};

const ru_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этот список пока не добавлены никакие сокращения.`)
};

const es_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se han añadido atajos a esta lista`)
};

const zh_cn2_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此列表尚未添加任何缩写形式。`)
};

const ja_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリストにはまだショートフォームが追加されていません`)
};

const hi_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सूची में अभी तक कोई संक्षिप्त रूप नहीं जोड़ा गया है।`)
};

const pt_pt2_no_shortforms_added = /** @type {(inputs: No_Shortforms_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma abreviação foi adicionada a esta lista ainda.`)
};

/**
* | output |
* | --- |
* | "No shortforms added to this list yet" |
*
* @param {No_Shortforms_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_shortforms_added = /** @type {((inputs?: No_Shortforms_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Shortforms_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_shortforms_added(inputs)
	if (locale === "de") return de_no_shortforms_added(inputs)
	if (locale === "it") return it_no_shortforms_added(inputs)
	if (locale === "ru") return ru_no_shortforms_added(inputs)
	if (locale === "es") return es_no_shortforms_added(inputs)
	if (locale === "zh-CN") return zh_cn2_no_shortforms_added(inputs)
	if (locale === "ja") return ja_no_shortforms_added(inputs)
	if (locale === "hi") return hi_no_shortforms_added(inputs)
	if (locale === "pt-PT") return pt_pt2_no_shortforms_added(inputs)
	return en_no_shortforms_added(inputs)
});